import type EligibilityWidgetFormData from '../../../types/eligibilityWidget/EligibilityWidgetFormData';
import { type RegisterOptions, useForm } from 'react-hook-form';
import type EligibilityWidgetFormValidatorOptions from '../../../types/eligibilityWidget/EligibilityWidgetFormValidatorOptions';
import type { EligibilityWidgetTextKeys } from '../../../types/eligibilityWidget/EligibilityWidgetTextKeys';
import useTranslation from '../../states/translation/useTranslation';

const useEligibilityWidgetForm = () => {
  const { register, control, handleSubmit, formState, getValues, setValue } = useForm<EligibilityWidgetFormData>();
  const { t } = useTranslation().actions;

  const getValidator = (
    fieldname: keyof EligibilityWidgetTextKeys,
    options:
      | EligibilityWidgetFormValidatorOptions<EligibilityWidgetFormData>
      | ((
          fieldname: keyof EligibilityWidgetTextKeys,
        ) => EligibilityWidgetFormValidatorOptions<EligibilityWidgetFormData>) = {},
  ) => {
    const validationOptions = typeof options === 'function' ? options(fieldname) : options;
    const { required = true, minLength, maxLength, pattern, validate } = validationOptions;

    return {
      required: required ? t('common.form.required-dynamic', t(fieldname)) : undefined,
      minLength: minLength
        ? { value: minLength, message: t('eligibility-widget.form.min-length', t(fieldname), minLength) }
        : undefined,
      maxLength: maxLength
        ? { value: maxLength, message: t('eligibility-widget.form.max-length', t(fieldname), maxLength) }
        : undefined,
      pattern: pattern
        ? { value: pattern, message: t('eligibility-widget.form.invalid-dynamic', t(fieldname)) }
        : undefined,
      validate: validate ?? undefined,
    } satisfies RegisterOptions;
  };

  return {
    register,
    control,
    handleSubmit,
    formState,
    setValue,
    getValues,
    getValidator,
  };
};

export default useEligibilityWidgetForm;
